// Import the functions you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBrkgG5j07CHvIB_gHvezkWJXlT-iS8dXs",
  authDomain: "morarafurnitures.firebaseapp.com",
  projectId: "morarafurnitures",
  storageBucket: "morarafurnitures.firebasestorage.app",
  messagingSenderId: "168881586447",
  appId: "1:168881586447:web:5c1ef5cb665a10dba5be7a",
  measurementId: "G-F6KMCFF19G"
};

// Initialize Firebase



// Initialize apps
const app = initializeApp(firebaseConfig); // default

// Services for app1
export const auth = getAuth(app);

// Services for app2
export const db = getFirestore(app);
